import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PrimaryHeader from "../../Components/PrimaryHeader/PrimaryHeader";
import TraveledCard from "../../Components/TravelCard/TravelCard";
import { LiaFileInvoiceDollarSolid } from "react-icons/lia";
import {
  MdOutlineAccountCircle,
  MdOutlineManageAccounts,
} from "react-icons/md";
import { SlWallet } from "react-icons/sl";
import { PiBuildingApartmentFill } from "react-icons/pi";
import SaleGrowthGraph from "../../Components/SaleGrowthGraph/SaleGrowthGraph";
import ParentComponent from "../../Components/ParentComponent/ParentComponent";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { GrUserWorker } from "react-icons/gr";
import {
  getClientbyid,
  getStatesByClientId,
  getTransactionByClientId,
  toggleClientActivation,
  updateClient,
} from "../../Actions/actions";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import moment from "moment";
import CustomToast from "../../Components/CustomToast/CustomToast";
import { FaLaptopHouse } from "react-icons/fa";
import { HiOutlineClipboardList, HiOutlineUserGroup } from "react-icons/hi";
import { subscriptionColors } from "../../Reducers/reducers";

function ClientManagmentDetail() {
  const dispatch = useDispatch();

  const { id } = useParams();
  const { singleClient, loginData, loader } = useSelector(
    (state) => state.userReducer
  );

  const [transactionData, setTransactionData] = useState([]);
  const [isClientActive, setIsClientActive] = useState(false);
  const [clientStates, setClientStates] = useState(null);

  const statusColors = {
    "Over Due": "bg-red-200 text-red-700",
    Paid: "bg-green-200 text-green-700",
    Pending: "bg-yellow-200 text-yellow-700",
  };
  console.log(clientStates, "k");
  const clientDetails = [
    {
      label: "Total Sales",
      value: "AED " + (clientStates?.dashboardTotals?.totalSales || 0),
      icon: <LiaFileInvoiceDollarSolid className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Accounts",
      value: clientStates?.dashboardTotals?.totalAccounts || 0,
      icon: <MdOutlineAccountCircle className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Leads",
      value: clientStates?.dashboardTotals?.totalLeads || 0,
      icon: <HiOutlineUserGroup className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Employees",
      value: clientStates?.dashboardTotals?.totalEmployees || 0,
      icon: <GrUserWorker className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Expected Monthly Revenue",
      value:
        "AED " + (clientStates?.dashboardTotals?.expectedMonthlyRevenue || 0),
      icon: <LiaFileInvoiceDollarSolid className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Assets",
      value: clientStates?.dashboardTotals?.totalAssetTypes || 0,
      icon: <FaLaptopHouse className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Roles",
      value: clientStates?.dashboardTotals?.totalRoles || 0,
      icon: <HiOutlineClipboardList className="w-10 h-10 text-secondary" />,
    },
  ];

  const clientDetails2 = [
    {
      label: "Total Sales",
      value: "321",
      icon: <LiaFileInvoiceDollarSolid className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Accounts",
      value: "21",
      icon: <MdOutlineManageAccounts className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Leads",
      value: "AED 3443",
      icon: <SlWallet className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Employees",
      value: "AED 3443",
      icon: <SlWallet className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Expected Monthly Revenue",
      value: "AED 3443",
      icon: <PiBuildingApartmentFill className="w-10 h-10 text-secondary" />,
    },
    {
      label: "Total Roles",
      value: "4",
      icon: <SlWallet className="w-10 h-10 text-secondary" />,
    },
  ];

  const [features, setFeatures] = useState([
    { name: "CRM", enabled: singleClient?.crm, types: "crm" },
    { name: "HRMS", enabled: singleClient?.hrms, types: "hrms" },
    {
      name: "Reporting and Analytics",
      enabled: singleClient?.reportingAnalytics,
      types: "reportingAnalytics",
    },
    {
      name: "Geolocation Services",
      enabled: singleClient?.geolocationService,
      types: "geolocationService",
    },
    {
      name: "User Management",
      enabled: singleClient?.userManagement,
      types: "userManagement",
    },
  ]);

  useEffect(() => {
    setIsClientActive(singleClient?.users?.isActive);
    dispatch(
      getStatesByClientId(loginData?.accessToken, singleClient?.id, (data) => {
        setClientStates(data?.data);
      })
    );
    dispatch(
      getTransactionByClientId(
        loginData?.accessToken,
        singleClient?.id,
        (data) => {
          setTransactionData(data?.data);
        }
      )
    );
  }, [singleClient]);

  useEffect(() => {
    const mapData = features.map((item) => {
      return {
        ...item,
        enabled: singleClient[item.types],
      };
    });
    setFeatures(mapData);
  }, [singleClient]);

  const saleGrowth = [
    { month: "Jan", earnings: 2000 },
    { month: "Feb", earnings: 2500 },
    { month: "Mar", earnings: 1800 },
    { month: "Apr", earnings: 2000 },
    { month: "May", earnings: 2200 },
    { month: "Jun", earnings: 2600 },
    { month: "Jul", earnings: 2800 },
    { month: "Aug", earnings: 3000 },
    { month: "Sep", earnings: 2700 },
    { month: "Oct", earnings: 3500 },
    { month: "Nov", earnings: 3200 },
    { month: "Dec", earnings: 2800 },
  ];

  const toggleFeature = (index) => {
    setFeatures((prev) =>
      prev.map((feature, i) =>
        i === index ? { ...feature, enabled: !feature.enabled } : feature
      )
    );
  };

  const updateFeatures = () => {
    const data = { ...singleClient };
    features.forEach((element) => {
      data[element.types] = element.enabled;
    });

    dispatch(
      updateClient(singleClient?.id, data, loginData?.accessToken, () => {
        dispatch(
          getClientbyid(
            loginData?.accessToken,
            singleClient?.id,
            () => {},
            () => {}
          )
        );
        toast.success(
          <CustomToast type={"Success"} message={"Feature Access Updated"} />,
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            icon: false,
            closeButton: false,
          }
        );
      })
    );
  };

  return (
    <ParentComponent style="scrollbar-none">
      <PrimaryHeader />
      <div className="px-6 py-8 shadow-md rounded-lg border">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center gap-4">
            <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
              {singleClient?.logo ? (
                <img src={singleClient?.logo} />
              ) : (
                <p className="font-bold text-gray-400 text-lg">
                  {singleClient?.businessName?.slice(0, 1)}
                </p>
              )}
            </div>
            <h1 className="font-bold text-lg text-gray-800">{id}</h1>
          </div>
          <span
            className={`${
              isClientActive ? " bg-green-600" : "bg-red-600"
            }  text-white text-xs font-bold px-2 py-1 rounded-md cursor-pointer ${
              isClientActive ? "hover:bg-green-800" : "hover:bg-red-800"
            } transition`}
            onClick={() => {
              console.log("loginData?.accessToken", loginData?.accessToken);
              console.log("singleClient?.id,", singleClient?.id);
              dispatch(
                toggleClientActivation(
                  singleClient?.id,
                  loginData?.accessToken,
                  (data) => {
                    setIsClientActive(data?.data?.isActive);
                  }
                )
              );
            }}
          >
            {isClientActive ? "Active" : "Deactivated"}
          </span>
        </div>

        <div className="mt-8">
          <h2 className="text-xl font-bold mb-4">Client Profile</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 items-start gap-6">
            {/* Left Side */}
            <div className="space-y-4">
              <div>
                <p className="text-gray-800 text-sm font-bold">Client ID</p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.id}
                </p>
              </div>

              <div>
                <p className="text-gray-800 text-sm font-bold">Business Name</p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.businessName}
                </p>
              </div>

              {!!singleClient?.businessWebsite && (
                <div>
                  <p className="text-gray-800 text-sm font-bold">Website</p>
                  <p className="text-gray-800 text-sm font-regular">
                    {singleClient?.businessWebsite}
                  </p>
                </div>
              )}

              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Client Industry
                </p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.clientIndustry}
                </p>
              </div>

              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Business Whatsapp
                </p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.businessWhatsapp}
                </p>
              </div>

              {!!singleClient?.companyActivity && (
                <div>
                  <p className="text-gray-800 text-sm font-bold">
                    Company Activity
                  </p>
                  <p className="text-gray-800 text-sm font-regular">
                    {singleClient?.companyActivity}
                  </p>
                </div>
              )}

              {!!singleClient?.companySize && (
                <div>
                  <p className="text-gray-800 text-sm font-bold">
                    Company Size
                  </p>
                  <p className="text-gray-800 text-sm font-regular">
                    {singleClient?.companySize}
                  </p>
                </div>
              )}

              {!!singleClient?.contactPersonName && (
                <div>
                  <p className="text-gray-800 text-sm font-bold">
                    Contact Person
                  </p>
                  <p className="text-gray-800 text-sm font-regular">
                    {singleClient?.contactPersonName}
                  </p>
                </div>
              )}

              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Primary Contact
                </p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.contactPersonPhoneNumber}
                </p>
              </div>

              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Subscription Type
                </p>
                <span
                  className={`px-3 py-1 rounded-md text-xs font-semibold self-center shadow-sm ${
                    subscriptionColors[singleClient?.subscriptionType]
                  }`}
                >
                  {singleClient?.subscriptionType}
                </span>
              </div>
            </div>

            {/* Right Side */}
            <div className="space-y-4">
              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Account Manager
                </p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.businessName}
                </p>
                <p className="text-gray-400 text-sm font-regular">
                  {singleClient?.email}
                </p>
              </div>

              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Billing Address
                </p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.businessAddress}, {singleClient?.businessCity},{" "}
                  {singleClient?.businessCountry}
                </p>
              </div>

              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Trade License Number
                </p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.tradeLicenseNumber}
                </p>
              </div>

              <div>
                <p className="text-gray-800 text-sm font-bold">Vat Tax Id</p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.vatTaxId}
                </p>
              </div>

              <div>
                <p className="text-gray-800 text-sm font-bold">Phone</p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.contactPersonPhoneNumber}
                </p>
              </div>
              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Contact Person Whatsapp
                </p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.contactPersonWhatsapp}
                </p>
              </div>
              <div>
                <p className="text-gray-800 text-sm font-bold">Postal Code</p>
                <p className="text-gray-800 text-sm font-regular">
                  {singleClient?.postalCode}
                </p>
              </div>
              <div>
                <p className="text-gray-800 text-sm font-bold">
                  Payment Status
                </p>
                <p
                  className={`text-xs px-3 w-20 text-center py-1 mt-2  font-semibold rounded ${
                    singleClient?.paymentStatus === "pending"
                      ? "bg-yellow-200 text-yellow-800"
                      : "bg-green-200 text-green-700"
                  }`}
                >
                  {singleClient?.paymentStatus?.charAt(0).toUpperCase() +
                    singleClient?.paymentStatus?.slice(1)}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-4 mt-8">
          {clientDetails.map((metric, idx) => {
            return (
              <TraveledCard
                metric={metric}
                idx={idx}
                maxWidth={"max-w-[300px]"}
                minWidth={"min-w-[200px]"}
              />
            );
          })}
        </div>

        {/* <div className="mt-8">
          <h2 className="text-lg font-bold text-gray-800 mb-4">
            Features Access
          </h2>

          <div className="bg-gray-100 rounded-lg p-6">
            {features.map((feature, index) => (
              <div
                key={feature.name}
                className="flex justify-between items-center py-2"
              >
                <span className="text-gray-800 text-sm font-regular">
                  {feature.name}
                </span>
                <button
                  className={`w-10 h-5 rounded-full flex items-center px-1 transition ${
                    feature.enabled ? "bg-primary" : "bg-gray-300"
                  }`}
                  onClick={() => toggleFeature(index)}
                >
                  <div
                    className={`w-4 h-4 bg-white rounded-full shadow-md transform transition ${
                      feature.enabled ? "translate-x-4" : "translate-x-0"
                    }`}
                  ></div>
                </button>
              </div>
            ))}
          </div>

          <div className="flex flex-col items-end mt-6">
            {loader ? (
              <Loader />
            ) : (
              <button
                className=" bg-primary text-white px-5 py-2 rounded-lg hover:bg-gray-700 transition text-sm font-bold"
                onClick={updateFeatures}
              >
                Save Changes
              </button>
            )}
          </div>
        </div> */}
        <div className="h-6"></div>
        <SaleGrowthGraph data={singleClient?.id} />

        {/* <div className="flex flex-wrap gap-4 mt-8">
          {clientDetails2.map((metric, idx) => {
            return (
              <TraveledCard
                metric={metric}
                maxWidth={"max-w-[300px]"}
                minWidth={"min-w-[200px]"}
                idx={idx}
              />
            );
          })}
        </div> */}

        <div className="overflow-x-auto min-w-full mt-12 rounded-lg shadow-md">
          <table className="min-w-full text-left">
            <thead className="bg-[#361D3214]">
              <tr>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[100px]">
                  Transaction ID
                </th>

                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[160px]">
                  Subscription Type
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px]">
                  Payment Date
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[100px]">
                  Amount (AED)
                </th>
                <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px]">
                  Payment Method
                </th>
                {/* <th className="py-4 px-4 text-gray-500 font-semibold text-sm min-w-[150px]">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {transactionData?.length > 0 ? (
                transactionData?.map((transaction) => (
                  <tr key={transaction.id} className="border-b">
                    <td className="py-3 px-4 text-sm font-medium text-gray-800 min-w-[100px]">
                      {transaction.invoiceNumber}
                    </td>

                    <td className="py-3 pl-10 min-w-[160px]">
                      <span
                        className={`px-3 py-1 rounded-md text-xs font-semibold shadow-sm ${
                          subscriptionColors[transaction.subscriptionType]
                        }`}
                      >
                        {transaction?.subscriptionType}
                      </span>
                    </td>
                    <td className="py-3 pl-6 text-sm font-normal text-gray-800 min-w-[150px]">
                      {moment(transaction?.invoiceDate).format("DD-MMM-yy")}
                    </td>
                    <td className="py-3 pl-8 text-sm font-normal text-gray-800 min-w-[100px]">
                      AED {transaction.amount / 100}
                    </td>
                    <td className="py-3 pl-10 text-sm font-normal text-gray-800 min-w-[150px]">
                      {transaction?.paymentMethod}
                    </td>
                    {/* <td className="py-4 px-4 min-w-[150px]">
                      <button className=" text-xs rounded-lg hover:bg-gray-600 font-bold text-white bg-primary py-1 px-2">
                        Send Reminder
                      </button>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center text-gray-500 py-4">
                    No transaction found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </ParentComponent>
  );
}

export default ClientManagmentDetail;
